import React from "react";
import PageComponent from "../../../page/PageComponent";
import UserService from "../../../../../services/UserService";
import UserInformations from "./UserInformations";
import CommonUtil from "../../../../../utils/CommonUtil";

class UserInformationsContainer extends PageComponent {
  constructor(props) {
    super(props);
    this.userService = new UserService();
    this.state = {};
  }

  componentDidMount() {
    this.loadModifiedBy();
    this.loadLifeCycleChangeBy();
  }

  loadModifiedBy = () => {
    const url = this.props.knowledgeItem._links.modifiedBy.href;
    this.props.loadParty(url, this.onModifiedByLoad);
  };

  onModifiedByLoad = data => {
    this.setState({
      modifiedBy: data
    });
  };

  loadLifeCycleChangeBy = () => {
    const url = this.props.knowledgeItem._links.lifeCycleChangeBy.href;
    this.props.loadParty(url, this.onLifeCycleChangeByLoad);
  };

  onLifeCycleChangeByLoad = data => {
    this.setState({
      lifeCycleChangeBy: data
    });
  };

  render() {
    return (
      <UserInformations
        recordedBy={this.props.knowledgeItem.recordedBy}
        modifiedBy={this.state.modifiedBy}
        lifeCycleChangeBy={this.state.lifeCycleChangeBy}
        recordedTimeStampData={CommonUtil.formatDateTime(
          this.props.knowledgeItem.recordedTimeStamp
        )}
        modifiedTimeStampData={CommonUtil.formatDateTime(
          this.props.knowledgeItem.modifiedTimeStamp
        )}
        lifeCycleChangeTimeStampData={CommonUtil.formatDateTime(
          this.props.knowledgeItem.lifeCycleChangeTimeStamp
        )}
      />
    );
  }
}

export default UserInformationsContainer;
